import { call } from 'redux-saga/effects';
import { fetchSuggestionsRequest } from '../Suggestions/sagas';

export function* handleSagaErrors(errorCode) {
  switch (errorCode) {
    case 404:
      yield call(fetchSuggestionsRequest);
      break;
    default:
      break;
  }
}



// WEBPACK FOOTER //
// ./app/Error/sagas.js